import Vue from 'vue'
import axios from 'axios/index'
import SQL from 'sql.js'

const getUserPrograms = (state, getters, commit, rootState, rootGetters) => new Promise((resolve, reject) => {
  axios({
    url: process.env.API_URL + `/ws/playerservice/groups/user/` + rootState.user.userId,
    method: 'GET',
    headers: {
      Authorization: 'Bearer ' + rootGetters.token
    }
  }).then(response => {
    if (response) {
      resolve(response)
    } else {
      reject(Error('Game not found!'))
    }
  }).catch(error => {
    commit('flashError', error.message, { root: true })
  })
})

const getGameSession = (dispatch, state, getters, commit, rootState, rootGetters, gameData) => new Promise((resolve, reject) => {
  // console.log('Fetching game session...')
  axios({
    url: process.env.API_URL + `/ws/playerservice/sessioncount/group/${gameData.groupId}/deck/${gameData.deckId}`,
    method: 'GET',
    headers: {
      Authorization: 'Bearer ' + rootGetters.token
    }
  }).then(response => {
    if (response) {
      // TODO: @dvikas
      dispatch('fetchGameActivity'
        , {sessionId: response.data.sessionId, memberId: gameData.memberId, groupId: gameData.groupId})

      commit('setGameSessionInGroup', {groupId: gameData.groupId, sessionData: response.data})

      resolve(response)
    } else {
      reject(Error('Game session not found!'))
    }
  }).catch(error => {
    commit('flashError', error.message, { root: true })
  })
})

const getMemberLevels = (state, getters, commit, rootState, rootGetters, sessionData, gameData) => new Promise((resolve, reject) => {
  const scheduleId = sessionData.scheduleId
  const memberId = gameData.memberId
  axios({
    url: process.env.API_URL + `/ws/playerservice/schedule/${scheduleId}/member/${memberId}/memberlevel`,
    method: 'GET',
    headers: {
      Authorization: 'Bearer ' + rootGetters.token
    }
  }).then(response => {
    if (response) {
      resolve({response, scheduleId, memberId})
    } else {
      reject(Error('Game played level not found!'))
    }
  }).catch(error => {
    commit('flashError', error.message, { root: true })
  })
})

const state = {
  courseLevelLoadedAfterLogin: false,
  locationLoader: false,
  memberId: 0,
  badgeScore: -1,
  badgeDetails: {},
  groups: [],
  levels: [],
  lastPlayedLevel: 0,
  badgePricing: [],
  userAddress: {},
  examStatus: -1 // 0 => Not ready, 1 => Ready, 2 => In Exam, 3=> Retake
}

const getters = {
  getCourseLevelLoadedAfterLogin (state) {
    return state.courseLevelLoadedAfterLogin
  },
  getBadgeDetails (state) {
    return state.badgeDetails
  },
  getBadgePricing (state) {
    return state.badgePricing
  },
  getUserAddress (state) {
    return state.userAddress
  },
  getExamStatus (state) {
    return state.examStatus
  },
  getLastPlayedLevel (state) {
    return state.lastPlayedLevel
  },
  getMemberId (state) {
    return state.memberId
  },
  getGroups (state) {
    return state.groups
  },
  getLevels (state) {
    return state.levels
  },
  getBadgeScore (state) {
    return state.badgeScore
  },
  getLocationLoader (state) {
    return state.locationLoader
  }
}

const actions = {

  fetchBadgePricing ({dispatch, state, getters, commit, rootGetters}, deckId) {
    axios({
      url: process.env.API_URL + `/ws/checkout/course/${deckId}/products/badge`,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + rootGetters.token
      }
    }).then(response => {
      if (response) {
        commit('setBadgePricing', response.data)
      } else {
        Error('Unable to fetch Badge pricing!')
      }
    }).catch(error => {
      commit('flashError', error.message, { root: true })
    })
  },

  setGameReadState ({dispatch, state, getters, commit, rootGetters}, gameData) {
    const todayDate = new Date(new Date().toString().split('GMT')[0] + ' UTC').toISOString().split('.')[0]
    // console.log('set game read state...', todayDate)
    axios({
      url: process.env.API_URL + `/ws/activitytracker/syncreadstate/member/${gameData.memberId}/session/${gameData.sessionId}/lastsyncdate/${todayDate}`,
      method: 'POST',
      data: gameData.content,
      headers: {
        Authorization: 'Bearer ' + rootGetters.token
      }
    }).then(response => {
      if (response) {
        // console.log(response)
        commit('setGameReadState', {groupId: gameData.groupId, activityData: response.data})
      } else {
        Error('Setting Game read State Failed!')
      }
    }).catch(error => {
      commit('flashError', error.message, { root: true })
    })
  },

  fetchUserAddress ({dispatch, state, getters, commit, rootGetters}, deckId) {
    commit('setLocationLoader', true)
    axios({
      url: process.env.API_URL + `/ws/checkout/user/address?deck=${deckId}`,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + rootGetters.token
      }
    }).then(response => {
      commit('setLocationLoader', false)
      if (response) {
        commit('setUserAddress', response.data)
      } else {
        Error('User address not found!')
      }
    }).catch(error => {
      commit('flashError', error.message, { root: true })
    })
  },

  fetchBadgeDetails ({dispatch, state, getters, commit, rootGetters}, data) {
    axios({
      url: process.env.API_URL + `/ws/recall/badge/user/${data.userId}/deck/${data.deckId}`,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + rootGetters.token
      }
    }).then(response => {
      if (response) {
        commit('setBadgeDetails', response.data)
        commit('setBadgeScore', response.data.score)
      } else {
        Error('Badge Details not found!')
      }
    }).catch(error => {
      commit('flashError', error.message, { root: true })
    })
  },

  fetchGameActivity ({dispatch, state, getters, commit, rootGetters}, gameData) {
    // console.log('Fetching game activity...')
    axios({
      url: process.env.API_URL + `/ws/activitytracker/memberdata/session/${gameData.sessionId}/member/${gameData.memberId}`,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + rootGetters.token
      }
    }).then(response => {
      if (response) {
        commit('setGameActivityInGroup', {groupId: gameData.groupId, activityData: response.data})
      } else {
        Error('Game activity not found!')
      }
    }).catch(error => {
      commit('flashError', error.message, { root: true })
    })
  },

  fetchCourseLevels ({dispatch, state, getters, commit, rootState, rootGetters}, deckId) {
    dispatch('connectDb', deckId, {root: true})
      .then(dbObject => {
        const db = new SQL.Database(dbObject)
        db.exec(`PRAGMA query_only = true;`)
        const maxLevels = rootState.levelsCount
        const maxLevelsQuery = `SELECT * FROM levels ORDER BY level_number DESC LIMIT 1,${maxLevels}`
        let contents = db.exec(maxLevelsQuery)
        let levelsArr = contents[0].values
        const levels = []
        levelsArr.map((level, i) => {
          const data = {
            memberLevel: {},
            deck_id: level[0],
            id: level[1],
            name: level[2],
            test_weightage: level[4],
            level_up_cor: level[5],
            full_play: level[6]
          }
          levels.push(data)
        })
        // console.log(levels)
        commit('setLevels', levels)
      })
      .catch(err => {
        console.error(err)
      })
  },

  fetchAvailablePrograms ({state, getters, commit, rootState, rootGetters}, details) {
    // console.log('rootState.user', rootState.user)
    if (rootState.user.userId) {
      getUserPrograms(state, getters, commit, rootState, rootGetters)
        .then(response => {
          // console.log('fetchAvailablePrograms... before setting GROUPS...')
          // console.log(response.data.groups)
          commit('setGroups', response.data.groups)
        })
        .catch(err => {
          console.error(err)
        })
    }
  },

  fetchMemberLevels ({dispatch, state, getters, commit, rootState, rootGetters}, gameData) {
    // if (state.levels.length === 0) {
    commit('setLoadingCourseDialog', { status: true, msg: 'Fetching program details... [1/4]' }, { root: true })
    // }

    dispatch('connectDb', gameData.deckId, {root: true})
      .then(dbObject => {
        const db = new SQL.Database(dbObject)
        db.exec(`PRAGMA query_only = true;`)
        // console.log('Max Levels are', rootState.levelsCount)
        const maxLevels = rootState.levelsCount
        const maxLevelsQuery = `SELECT * FROM levels ORDER BY level_number DESC LIMIT 1,${maxLevels}`
        let contents = db.exec(maxLevelsQuery)
        let levelsArr = contents[0].values
        const levels = []
        levelsArr.map((level, i) => {
          const data = {
            memberLevel: {},
            deck_id: level[0],
            id: level[1],
            name: level[2],
            test_weightage: level[4],
            level_up_cor: level[5],
            full_play: level[6]
          }
          levels.push(data)
        })
        commit('setLevels', levels)
      })
      .then(() => {
        commit('setLoadingCourseDialog', { status: true, msg: 'Fetching program session... [2/4]' }, { root: true })
        return getGameSession(dispatch, state, getters, commit, rootState, rootGetters, gameData)
      })
      .then(session => {
        commit('setLoadingCourseDialog', { status: true, msg: 'Fetching program levels... [3/4]' }, { root: true })
        return getMemberLevels(state, getters, commit, rootState, rootGetters, session.data, gameData)
      })
      .then(mamberLevelsData => {
        commit('setLoadingCourseDialog', { status: true, msg: 'Fetching program scores... [4/4]' }, { root: true })
        const mamberLevels = mamberLevelsData.response
        const scheduleId = mamberLevelsData.scheduleId
        const memberId = mamberLevelsData.memberId

        commit('setExamStatus', mamberLevels.data.examStatus)
        commit('setMemberId', memberId)
        commit('setBadgeScore', mamberLevels.data.badgeScore)

        axios({
          url: process.env.API_URL + `/ws/recall/schedule/${scheduleId}/member/${memberId}/memberleveltests`,
          method: 'GET',
          headers: {
            Authorization: 'Bearer ' + rootGetters.token
          }
        }).then(response => {
          if (response) {
            let levels = state.levels
            for (const data of Object.entries(mamberLevels.data.memberLevels)) {
              const memberLevel = data[1]
              levels.map((level, i) => {
                if (level.id === memberLevel.level) {
                  commit('updateMemberLevel', {key: i, memberLevel: memberLevel})
                }
              })
              let levelTestScores = response.data.levelTestScores.find(score => parseInt(score.levelNumber) === parseInt(memberLevel.level))
              if (typeof levelTestScores !== 'undefined') {
                commit('updateMemberLevelTestScores', { key: memberLevel.level, levelTestScores: levelTestScores.scores })
              }
            }
          } else {
            Error('Game played level not found!')
          }
        }).then(() => {
          // console.log('All REQUESTS DONE!!')
          commit('setLoadingCourseDialog', { status: false, msg: '' }, { root: true })
        }).catch(error => {
          commit('flashError', error.message, { root: true })
        })
      })
      .catch(err => {
        console.error(err)
      })
  }
}

// mutations
const mutations = {
  setGameReadState (state, {groupId, activityData}) {
    // const viewId = activityData.updatedReadStateData[0].views[0].id
    state.groups.map((group, index) => {
      if (group.groupId === parseInt(groupId)) {
        state.groups[index].activityCounter = activityData.activityCounter
        state.groups[index].tokens = activityData.tokens

        if (activityData.updatedReadStateData.length > 0) {
          let groupsData = state.groups[index]
          activityData.updatedReadStateData[0].views.forEach(function (view, index) {
            groupsData.viewsViewed.push(view.id)
            // console.log('Setting read state', view.id)
          })
          Vue.set(state.groups, index, groupsData)
        } else {
          console.error('updatedReadState record not found')
        }
      }
    })
  },

  setGameActivityInGroup (state, {groupId, activityData}) {
    state.groups.map((group, index) => {
      if (group.groupId === parseInt(groupId)) {
        // console.log(activityData.viewsViewed)
        let viewsViewed = []
        activityData.viewsViewed.forEach(function (data, index) {
          viewsViewed = [...viewsViewed, ...data.views]
          activityData.viewsViewed = viewsViewed
        })
        // console.log('vuex: Setting game activity')
        Vue.set(state.groups, index, {...group, ...activityData})
      }
    })
  },

  setGameSessionInGroup (state, {groupId, sessionData}) {
    state.groups.map((group, index) => {
      if (group.groupId === parseInt(groupId)) {
        // console.log('vuex: Setting game session')
        Vue.set(state.groups, index, {...group, ...sessionData})
      }
    })
  },

  setExamStatus (state, flag) {
    state.examStatus = flag
  },

  setMemberId (state, id) {
    state.memberId = id
  },

  setBadgeScore (state, id) {
    state.badgeScore = id
  },

  setGroups (state, data) {
    state.groups = data
  },

  setLevels (state, data) {
    state.levels = data
  },

  updateMemberLevel (state, dataJson) {
    let key = dataJson.key
    state.levels[key].memberLevel = dataJson.memberLevel
  },

  updateMemberLevelTestScores (state, dataJson) {
    let index = state.levels.findIndex(level => level.id === dataJson.key)
    if (index !== -1) {
      state.levels[index].levelTestScores = dataJson.levelTestScores
    }
  },

  updateCoinCount (state, groupId) {
    state.groups.forEach((group, index) => {
      if (group.groupId === groupId) {
        group.tokens = group.tokens - 1
        Vue.set(state.groups, index, group)
      }
    })
  },

  setLastPlayedLevel (state, level) {
    state.lastPlayedLevel = level
  },

  setBadgePricing (state, pricing) {
    state.badgePricing = pricing
  },

  setUserAddress (state, address) {
    state.userAddress = address
  },

  setBadgeDetails (state, data) {
    state.badgeDetails = data
  },

  setCourseLevelLoadedAfterLogin (state, status) {
    state.courseLevelLoadedAfterLogin = status
  },

  setLocationLoader (state, status) {
    state.locationLoader = status
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/course.js